// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-wrapper[data-v-685cdc22]{left:50%;position:fixed;top:5rem;transform:translateX(-50%);z-index:50}@media (min-width:1024px){.notification-wrapper[data-v-685cdc22]{top:8.5rem}}.fade-enter-active[data-v-685cdc22],.fade-leave-active[data-v-685cdc22]{transition:opacity .3s}.fade-enter[data-v-685cdc22],.fade-leave-to[data-v-685cdc22]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
